import { useState } from 'react';
import { useSnackbar } from 'ui-components';

export const useClipboard = (initialValue = '', format = 'text/html') => {
  const snackbar = useSnackbar();

  const [value, setValue] = useState(initialValue);
  const [isCopying, setIsCopying] = useState(false);

  const copyToClipboard = async (newValue: string) => {
    if (isCopying) return;

    setIsCopying(true);
    setValue(newValue);

    try {
      if (format === 'text/html') {
        // Create a Blob for the HTML content
        const blob = new Blob([newValue], { type: 'text/html' });
        const clipboardItem = new ClipboardItem({ 'text/html': blob });

        // Use the clipboard API to write the blob content
        await navigator.clipboard.write([clipboardItem]);
      } else {
        // Fallback to writing plain text if not HTML
        await navigator.clipboard.writeText(newValue);
      }

      snackbar.success({
        description: 'The content has been copied to the clipboard',
      });
    } catch (err) {
      snackbar.error({
        description: 'Error copying to clipboard. Please try again',
      });
    } finally {
      setIsCopying(false);
    }
  };

  return { value, copyToClipboard, isCopying };
};
